import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const grey = constants.colors.ui.neutral[25];

export const buttonCss: CSSObject = {
  backgroundColor: grey,
  marginBottom: "8px",
  justifyContent: "space-between",
};

export const ulCss: CSSObject = {
  margin: 0,
  padding: 0,
  listStyle: "none",
};

export const noStudentsCss: CSSObject = {
  padding: "12px 16px",
};
